/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PersonTypes {
	User = 1,
	CompanyPerson = 2,
	StartUpper = 3,
	JobSeeker = 4,
	Student = 5,
	Young = 6,
	Immigrant = 7,
	LeaderGroupPerson = 8,
}
